import * as types from './types';

const changeCatalogMode = isListMode => {
    return {
        type: types.CHANGE_CATALOG_MODE,
        isListMode: isListMode
    };
};

export { changeCatalogMode };



// WEBPACK FOOTER //
// ./src/modules/Catalog/actions/actions.js